import { styled as e } from "styled-components";
//#region src/components/QuickActions/components/QuickActionTile.styled.ts
var t = e.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: ${({ theme: e }) => e.spacing(1.5)} ${({ theme: e }) => e.spacing(1)};
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.lg};
    background-color: ${({ theme: e }) => e.colors.card};
    cursor: pointer;
    transition: all ${({ theme: e }) => e.transitions.fast};

    &:hover:not(:disabled) {
        background-color: ${({ theme: e }) => e.colors.muted};
        border-color: ${({ theme: e, $tone: t }) => t === "destructive" ? e.colors.destructive : e.colors.primary};
        transform: translateY(-1px);
        box-shadow: ${({ theme: e }) => e.shadows.sm};
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`, n = e.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: ${({ theme: e }) => e.radii.md};
    background-color: ${({ theme: e }) => e.colors.secondary};
    color: ${({ theme: e, $tone: t }) => t === "destructive" ? e.colors.destructive : e.colors.primary};

    svg {
        width: 18px;
        height: 18px;
    }
`;
//#endregion
export { n as IconChip, t as Tile };
